export const gitVersion = {
  "commit": "b9cc453",
  "commitLong": "b9cc4535f50d42b00b1b55124b6ec2c5764357f8",
  "date": "2025-05-15T18:13:49.000Z",
  "buildNumber": "2026"
}